<i18n
  src="@/locales/views/service_provider/services/container_op/show_attachments.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_service_attachment.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="sp_services_container_op_show_schedule_path"
    :params="{
      service_provider_id: service_provider_id,
      container_scheduled_service_id: container_scheduled_service_id,
    }"
  />
  <bread-crumbs
    :labels="[module_name, container_service?.service_template?.name]"
  ></bread-crumbs>
  <template v-if="container_service">
    <container-scheduled-service-info
      :container_scheduled_service="container_scheduled_service"
    />
    <div class="flex justify-between mt-8 mb-2" v-if="container_service">
      <h3 class="items-center">
        <div class="panel-header-title">
          {{
            $t("labels.title", {
              service: container_service?.service_template?.name,
            })
          }}
        </div>
      </h3>
      <uploader-attachment
        :files="files"
        :newAttach="newAttach"
        @new="setNewAttachment"
      ></uploader-attachment>
    </div>
    <div class="flex flex-col" v-if="container_service">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t(
                        "model.container_service_attachment.service_template_file"
                      )
                    }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t(
                        "model.container_service_attachment.container_service_attach"
                      )
                    }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="attachment in attachments"
                  :key="attachment.id"
                >
                  <td class="table-cell">
                    {{ attachment.service_template_file.name }}
                  </td>
                  <td class="table-cell-main">
                    {{ attachment.container_service_attach.blob.filename }}
                  </td>
                  <td class="table-cell-action">
                    <i
                      class="fa-solid fa-spinner"
                      v-if="attachment.requesting"
                    ></i>
                    <template v-else>
                      <destroy-button-processing v-if="attachment.requesting" />
                      <destroy-button
                        v-else
                        :disabled_button="false"
                        @destroyEvent="destroy(attachment)"
                        :title="$t('labels.destroy_button_title')"
                        :message="$t('labels.destroy_button_message')"
                        :label_confirm="
                          $t('labels.destroy_button_label_confirm')
                        "
                      />
                      <span class="space-actions hidden sm:inline"></span>
                      <white-button
                        v-if="attachment.requesting"
                        icon="fa-solid fa-sync fa-spin"
                      />
                      <white-button
                        v-else
                        @click.prevent="download(attachment)"
                        icon="fa-solid fa-download"
                      />
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/show_attachments.js";

import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
import UploaderAttachment from "@/components/views/service_provider/services/container_op/UploaderAttachment.vue";
import ContainerScheduledServiceInfo from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceInfo.vue";

export default {
  components: {
    BreadCrumbs,
    ContainerScheduledServiceInfo,
    UploaderAttachment,
  },
  props: [
    "service_provider_id",
    "container_scheduled_service_id",
    "container_service_id",
  ],
  data() {
    return {
      container_scheduled_service: null,
      container_service: null,
      attachments: [],
    };
  },
  computed: {
    files: function () {
      return this.container_service?.service_template?.service_template_files;
    },
  },
  methods: {
    destroy: async function (attachment) {
      attachment.requesting = true;
      try {
        let response = await Requester.destroy({
          container_service_attachment_id: attachment.id,
          container_service_id: this.container_service_id,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.attachments.splice(this.attachments.indexOf(attachment), 1);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      attachment.requesting = false;
    },
    download: async function (attachment) {
      attachment.requesting = true;
      var response = await Requester.download({
        container_service_attachment_id: attachment.id,
        container_service_id: this.container_service_id,
      });
      const file = response.data;
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        attachment.container_service_attach.blob.filename
      );
      document.body.appendChild(fileLink);

      fileLink.click();
      attachment.requesting = false;
    },
    fetchSchedule: async function () {
      let response = await Requester.fetchSchedule({
        container_service_id: this.container_service_id,
      });
      let container_service = response.data;
      let container_scheduled_service =
        container_service.container_scheduled_service;
      container_scheduled_service.scheduled_at =
        container_scheduled_service.scheduled_at?.split(".")[0];
      container_scheduled_service.started_at =
        container_scheduled_service.started_at?.split(".")[0];
      container_scheduled_service.finished_at =
        container_scheduled_service.finished_at?.split(".")[0];
      this.attachments = container_service?.container_service_attachments;
      this.container_scheduled_service = container_scheduled_service;
      this.container_service = container_service;
    },
    goToEditContainerSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_container_path",
        params: {
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToEditSchedule: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_schedule_path",
        params: {
          container_scheduled_service_id: this.container_scheduled_service_id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToListSchedules: function () {
      this.$router.push({
        name: "sp_services_container_op_list_schedules_path",
        params: {
          service_provider_id: this.service_provider_id,
        },
      });
    },
    newAttach: async function ({ service_template_file_id, attach }) {
      try {
        let response = await Requester.create({
          container_service_id: this.container_service_id,
          service_template_file_id: service_template_file_id,
          attach: attach,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        return JSON.parse(response.data.container_service_attachment);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
    },
    setNewAttachment: function (attachment) {
      console.log(attachment);
      this.attachments.push(attachment);
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchSchedule();
      })
    );
  },
};
</script>
